import { keyframes } from '@emotion/react'
import { styled } from '@mui/material'

// Initializes a CSS variable that reflects banner max-width based on viewport height.
// Updates in real-time on resize without triggering React re-renders.
const initializeBannerMaxWidthCssVar = (() => {
  let initialized = false

  return () => {
    if (initialized) {
      return
    }

    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return
    }

    initialized = true

    const applyValue = () => {
      const width = window.innerHeight < 600 ? '50%' : '60%'

      document.documentElement.style.setProperty('--banner-max-width', width)
    }

    applyValue()

    window.addEventListener('resize', applyValue, { passive: true })
  }
})()

const bannerImageFloat = keyframes`
  0%, 100% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(25deg);
  }
`

export const StyledBannerImage = styled('img')(({ theme }) => {
  // Ensure the CSS variable is available on the client.
  initializeBannerMaxWidthCssVar()

  return {
    position: 'absolute',
    bottom: 0,
    right: 0,
    repeat: 'no-repeat',
    width: '100%',
    // Uses CSS variable that updates with viewport height in real-time
    maxWidth: 'var(--banner-max-width, 70%)',
    transformOrigin: 'right center', // Right edge stays static
    animation: `${bannerImageFloat} 6s ease-in-out infinite`,
    [theme.breakpoints.up('md')]: {
      width: '50%',
      maxWidth: '637px',
    },
  }
})
